import React from 'react';
import styles from 'styles/modules/newsStory/Index.module.scss';

const NotFound = ({ text, button = null }) => {
    return (
        <section className={styles.noStoryBlock}>
            <header>
                <h3>{text}</h3>
            </header>
            {button && <div className={styles.buttonWrapper}>{button}</div>}
        </section>
    );
};

export default NotFound;
